<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">                  
                <div class="row mb-1">                    
                    <div class="col-lg-12 mt-lg-0 mt-4">                        
                        <div ref="pdfContent" class="card mt-4 pdf-table">
                            <div class="card-header">
                                <h5>{{ associationName }}</h5>
                                <p class="mb-0 text-sm">{{ $t('location.UBN') }}: {{ ubn }}</p>
                                <p class="mb-0 text-sm">{{ $t('testmatings.Created') }}: {{ formatDate(created) }}</p>
                            </div>
                            <div class="card-body pt-0">
                                <div class="row">
                                    <div class="col-12">
                                        <table border="1">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th v-for="father in fathers" :key="father">{{ father }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="mother in mothers" :key="mother">
                                                    <td>{{ mother }}</td>
                                                    <td v-for="father in fathers" :key="father">
                                                        {{ getPercentage(mother, father) }}%
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>                                
                                </div>                                    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-12 mt-2">
                <router-link to="/testmating" class="btn btn-sm bg-gradient-danger float-start">{{ $t('common.Cancel') }}</router-link>
                <button v-on:click="downloadPdf" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Download_PDF') }}</button>
            </div>            
        </div>
    </div>        
</template>

<script>
import axios from 'axios'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export default {
    name: 'Testmating_report_page',
     data() {
        return {
            associationName:'',
            ubn:'',
            created:'',
            groupGuid:'',
            testmatings: [], // fetched from API
        };
    },
    computed: {
        fathers() {
            return [...new Set(this.testmatings.map(m => m.fatherStudbookNumber))];
        },
        mothers() {
            return [...new Set(this.testmatings.map(m => m.motherStudbookNumber))];
        }
    },
    async mounted() 
    {    
        this.groupGuid = this.$route.params.id;
        await this.fetchTestMatings();
    },
    methods: {
        getPercentage(mother, father) {
            const match = this.testmatings.find(
                m => m.fatherStudbookNumber === father && m.motherStudbookNumber === mother
            );
            return match ? match.inbreedingPercentage : '0';
        },
        formatDate(dateStr) {
            if (!dateStr) return '';
            const [year, month, day] = dateStr.split('-');
            return `${day}-${month}-${year}`;
        },
        async fetchTestMatings() 
        {
            try { 
                this.$store.commit('setShowLoading', true);

                const response = await axios.get("testmating/group", {
                    params: {
                        groupGuid: this.groupGuid
                    }
                });                
                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    this.testmatings = result.data;

                    if (this.testmatings.length > 0) {
                        this.associationName = this.testmatings[0].associationName;
                        this.ubn = this.testmatings[0].ubn;
                        this.created = this.testmatings[0].created;                        
                    }

                } else {
                    this.$showSuccess('errors.Error_fetching_testmatings');
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },    
        async downloadPdf() {
            const element = this.$refs.pdfContent;
            const canvas = await html2canvas(element, {
                backgroundColor: '#ffffff'
            });            
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('landscape', 'mm', 'a4');            
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            pdf.save('InbreedingMatrix.pdf');
        }
    }
}
</script>
<style scoped>
    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        border: 1px solid #000; /* Ensures all borders show */
        padding: 8px;
        text-align: center;
        font-size: 12px;
    }

    .pdf-table, 
    .pdf-table * {
        background-color: white !important;
        box-shadow: none !important;
    }

    .card.pdf-table {
        background-color: white !important;
        border: none !important;
    }
</style>